import { render, staticRenderFns } from "./CajaDiaria.vue?vue&type=template&id=31b56ab2&scoped=true"
import script from "./CajaDiaria.vue?vue&type=script&lang=ts"
export * from "./CajaDiaria.vue?vue&type=script&lang=ts"
import style0 from "./CajaDiaria.vue?vue&type=style&index=0&id=31b56ab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b56ab2",
  null
  
)

export default component.exports